import {
  TransactionDataResponseDto,
  TransactionResponseDto} from "../dto/response/transaction-response-dto";
import { Transaction, TransactionPagination } from "../model/transaction.model";

export function fromTransactionResponseToTransaction(
  dto: TransactionResponseDto
): Transaction {
  const dataArray = dto.data.map((transaction) => {
    return {
      id: transaction.id,
      walletId: transaction.walletId,
      amount: transaction.amount,
      type: transaction.type,
      status: transaction.status,
      description: transaction.description,
      createdAt: transaction.createdAt,
      updatedAt: transaction.updatedAt,
      txId: transaction.txId,
      originId: transaction.originId} as TransactionDataResponseDto;
  });
  return {
    data: {
      [dto.pagination.page]: dataArray},
    pagination: {
      total: dto.pagination.total,
      page: parseInt(dto.pagination.page, 10),
      pageSize: dto.pagination.pageSize,
      totalPage: dto.pagination.totalPage} as TransactionPagination} as Transaction;
}
